import { paramDsName, paramXPath } from '../constants/parameterNames';
import { typeDataSource, typeXPath } from '../constants/parameterTypes';
import { failure, success } from "../helpers/commandResult";
import { deleteNodes } from "../helpers/qRules.node.helpers";

const requiredParameters = [
    {
        name: paramXPath,
        description: 'XPath to delete. It can be filtered in the case of a repeating group or field',
        type: typeXPath,
        dsParentName: paramDsName,
    },
];
const optionalParameters = [
    {
        name: paramDsName,
        description: 'Only needs to be specified if the XPath to delete is not located in the Main data source',
        type: typeDataSource,
    },
];
const description = "Deletes an xml node specified by an XPath.";

const ERROR_MISSING_NODE = "Could not locate field to delete.";

function Delete(params) {

    const execute = () => {
        const commonFunctions = params.commonFunctions;
        const dataSources = params.dataSources;

        const dsname = commonFunctions.getParamValue(paramDsName);
        const xpath = commonFunctions.getParamValue(paramXPath);
        const dom = dataSources.getDom(dsname);

        const deleteCount = deleteNodes(dom, xpath);
        const isSuccess = deleteCount > 0;

        return isSuccess
            ? success()
            : failure(ERROR_MISSING_NODE);
    };

    return {
        description,
        requiredParameters,
        optionalParameters,
        execute,
    };
}

export default Delete;